import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const stampLengthColumn: CalculationColumn = {
    dataIndex: ['stamp', 'length'],
    title: 'Д',
    width: 35,
    render: renderCalcPos((r, v) =>
        r.withoutCutting ? r.virtualStamp?.length : (r.stamp?.length ?? v)
    ),
    onCell: onAnyStandardCell,
}
